import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BEDataService } from '../../services/businessEvent/beData.service';
import { ConfigDataService, enumUIConfig } from '../../services/configuration/configData.service';
import { KeyValuePair } from '../../models/keyvaluepair.model';

enum enumAsyncLoad {
    UIConfigs = 1,
    BEData = 2,
};


@Component({
    selector: 'msw-navbar',
    template: require('./navbar.component.html'),
    styles: [require('../app/app.component.css')]
})

export class NavBarComponent {
    private _isItineraryDisabled: boolean = true;
    private _isVehicleSelectionDisabled: boolean = true;
    private _isExtrasDisabled: boolean = true;
    private _isReviewDisabled: boolean = true;
    private _isConfirmationDisabled: boolean = true;

    private _isItineraryActive: boolean = false;
    private _isVehicleSelectionActive: boolean = false;
    private _isExtrasActive: boolean = false;
    private _isReviewActive: boolean = false;
    private _isConfirmationActive: boolean = false;

    private _navBarMainColour: string = "#1577B8";
    private _navBarDisabledColour: string = "lightgray";

    private _foregroundItinerary: string = "";
    private _backgroundItinerary: string = "";
    private _foregroundVehicleSelection: string = "";
    private _backgroundVehicleSelection: string = "";
    private _foregroundExtras: string = "";
    private _backgroundExtras: string = "";
    private _foregroundReview: string = "";
    private _backgroundReview: string = "";
    private _foregroundConfirmation: string = "";
    private _backgroundConfirmation: string = "";

    private _fullyLoaded: boolean = false;
    private _loaded = [
        {
            step: enumAsyncLoad.UIConfigs,
            loaded: false,
        },
        {
            step: enumAsyncLoad.BEData,
            loaded: false,
        }
    ];

    public constructor(private _beDataService: BEDataService,
        private _configDataService: ConfigDataService,
        private _httpClient: HttpClient,
        @Inject('BASE_URL') private _baseUrl: string) { }

    private async ngOnInit() {
        //invoke this class' refreshMenu method if the _beDataService's refreshMenu method is invoke
        this._beDataService.invokeRefreshMenu.subscribe(activeStep => {
            this.refreshMenu(activeStep);
            this.asyncLoaded(enumAsyncLoad.BEData);
        });

        //get the configured UIConfigs
        if (this._configDataService.uiConfigs == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/UIConfigs').subscribe(result => {
                this._configDataService.uiConfigs = result;
                this.asyncLoaded(enumAsyncLoad.UIConfigs);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.UIConfigs);
    }

    //
    //component management
    //
    private asyncLoaded(step: enumAsyncLoad) {
        let fullyLoaded: boolean = true;

        for (var i = 0; i < this._loaded.length; i++) {
            if (this._loaded[i].step === step) {
                //record the given step as being loaded
                this._loaded[i].loaded = true;
            }
            else if (!this._loaded[i].loaded) {
                //check if all async steps have been loaded
                fullyLoaded = false;
            }
        }

        switch (step) {
            case enumAsyncLoad.UIConfigs:
                let navBarMainColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_NavBarMainColour);
                let navBarDisabledColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_NavBarDisabledColour);

                if (navBarMainColour.trim().length > 0) {
                    this._navBarMainColour = navBarMainColour;
                }
                if (navBarDisabledColour.trim().length > 0) {
                    this._navBarDisabledColour = navBarDisabledColour;
                }
                break;

            case enumAsyncLoad.BEData:
                break;
        }

        this._fullyLoaded = fullyLoaded;
    }

    //set each step's current active/disabled status as required
    //this causes the correct style to be applied
    private refreshMenu(activeStep) {
        this._isItineraryDisabled = this._beDataService.isItineraryDisabled;
        this._isVehicleSelectionDisabled = this._beDataService.isVehicleSelectionDisabled;
        this._isExtrasDisabled = this._beDataService.isExtrasDisabled;
        this._isReviewDisabled = this._beDataService.isReviewDisabled;
        this._isConfirmationDisabled = this._beDataService.isConfirmationDisabled;

        this._isItineraryActive = (activeStep == "/beItinerary");
        this._isVehicleSelectionActive = (activeStep == "/beVehicleSelection");
        this._isExtrasActive = (activeStep == "/beExtras");
        this._isReviewActive = (activeStep == "/beReview");
        this._isConfirmationActive = (activeStep == "/beConfirmation");

        this._backgroundItinerary = this.getStyle("background", this._isItineraryActive, this._isItineraryDisabled);
        this._foregroundItinerary = this.getStyle("foreground", this._isItineraryActive, this._isItineraryDisabled);

        this._backgroundVehicleSelection = this.getStyle("background", this._isVehicleSelectionActive, this._isVehicleSelectionDisabled);
        this._foregroundVehicleSelection = this.getStyle("foreground", this._isVehicleSelectionActive, this._isVehicleSelectionDisabled);

        this._backgroundExtras = this.getStyle("background", this._isExtrasActive, this._isExtrasDisabled);
        this._foregroundExtras = this.getStyle("foreground", this._isExtrasActive, this._isExtrasDisabled);

        this._backgroundReview = this.getStyle("background", this._isReviewActive, this._isReviewDisabled);
        this._foregroundReview = this.getStyle("foreground", this._isReviewActive, this._isReviewDisabled);

        this._backgroundConfirmation = this.getStyle("background", this._isConfirmationActive, this._isConfirmationDisabled);
        this._foregroundConfirmation = this.getStyle("foreground", this._isConfirmationActive, this._isConfirmationDisabled);
    }

    public getStyle(property: string = "", isActive: boolean, isDisabled: boolean): string {
        var styleValue: string = "";

        if (isActive) {
            switch (property) {
                case "foreground":
                    styleValue = "white";
                    break;

                case "background":
                    styleValue = this._navBarMainColour;
                    break;
            }
        }
        else {
            switch (property) {
                case "foreground":
                    if (isDisabled) {
                        styleValue = this._navBarDisabledColour;
                    }
                    else {
                        styleValue = this._navBarMainColour;
                    }
                    break;

                case "background":
                    styleValue = "white";
                    break;
            }
        }

        return styleValue;
    }
}
